import { render } from "./ImpressumPage.vue?vue&type=template&id=9117bede"
import script from "./ImpressumPage.vue?vue&type=script&lang=js"
export * from "./ImpressumPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__